/**
 * Module 34 (WP-34.1) — deterministic level→background assignment.
 *
 * The scheduler itself moved to `@puzzlemania/shared` in Module 64 (WP-64.A1),
 * where Block Jam's music pool needs the same four guarantees and must not
 * import from a package named `background-gen`. Nothing about the schedule
 * changed: `assign-relocation.test.ts` pins every pool size 1–12 over 200
 * indices against a fixture captured from the pre-move implementation.
 *
 * What stays here is the background-shaped part — the 1-based *level* and the
 * `bgForLevel` name every call site already uses.
 *
 * This never touches the runtime background system — it only decides *which*
 * pool id a level gets; the caller renders it via `toCss`.
 */
import { buildPoolSchedule, pickFromPool } from '@puzzlemania/shared';
/**
 * Re-exported unchanged so Module 34's call sites and tests keep working. See
 * `buildPoolSchedule` for the mechanism and the §9 rules it implements.
 */
export const buildSchedule = buildPoolSchedule;
/**
 * Pick the background id for a 1-based `level` from `poolIds`.
 * Throws if the pool is empty — callers with an empty pool must fall back to
 * their own default instead of calling this (see the Block Jam integration).
 */
export function bgForLevel(poolIds, level) {
    if (!poolIds || poolIds.length === 0) {
        throw new Error('bgForLevel: poolIds must be non-empty');
    }
    const lvl = Math.max(1, Math.floor(level));
    return pickFromPool(poolIds, lvl - 1);
}
